import { gsap } from "gsap";

function parseValue(raw) {
  const normalized = raw.replace(/[\u00a0\u202f\u2009]/g, " ").trim();
  const match = normalized.match(/^([^0-9]*)([0-9][0-9\s.,]*)([^0-9]*)$/);

  if (!match) return null;

  const prefix = match[1].trim();
  const rawNum = match[2].replace(/[\s.,]/g, "");
  const suffix = match[3];
  const numeric = parseFloat(rawNum);

  if (isNaN(numeric)) return null;

  return { numeric, prefix, suffix };
}

function formatNumber(n, originalNumeric) {
  const rounded = Math.round(n);
  if (originalNumeric >= 1000) {
    return rounded.toLocaleString("fr-FR");
  }
  return rounded.toString();
}

function animateCountUp(el, raw) {
  const parsed = parseValue(raw);

  if (!parsed) {
    el.textContent = raw;
    return;
  }

  const { numeric, prefix, suffix } = parsed;
  const proxy = { val: 0 };

  el.textContent = prefix + "0" + suffix;

  gsap.to(proxy, {
    val: numeric,
    duration: 1.6,
    ease: "power3.out",
    onUpdate() {
      el.textContent = prefix + formatNumber(proxy.val, numeric) + suffix;
    },
    onComplete() {
      el.textContent = prefix + formatNumber(numeric, numeric) + suffix;
    },
  });
}

export function initKeyNumbers(sectionSelector) {
  const section = document.querySelector(sectionSelector);
  if (!section) return;

  const items = section.querySelectorAll(".number[data-value]");
  let hasPlayed = false;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !hasPlayed) {
          hasPlayed = true;
          items.forEach((el) => {
            animateCountUp(el, el.dataset.value);
          });
        }
      });
    },
    { threshold: 0.3 }
  );

  observer.observe(section);
}